/* SHISEI CS ボタン選択式FAQウィジェット
   - 知識は cs-faq.js（window.SHISEI_CS_FAQ・CS正本シートから build_faq.py が生成）
   - APIやサーバーは不要。カテゴリ→質問→固定回答のツリーをたどるだけ
   - 公式LINEの案内はフロー最後（未解決時）にのみ出す */
(function () {
  const root = document.getElementById('shisei-cs-faq');
  if (!root) return;

  const brand = (root.dataset.brand || 'essin').toLowerCase();
  const LINE_URL = root.dataset.lineUrl || '';
  const GREETING = root.dataset.greeting ||
    'サポートへようこそ。お問い合わせの内容を下のボタンからお選びください。';

  const data = (window.SHISEI_CS_FAQ || {})[brand];
  if (!data || !data.categories || !data.categories.length) {
    root.innerHTML = '<div class="csf-box"><div class="csf-log">'
      + '<div class="csf-msg csf-assistant">ただいま準備中です。恐れ入りますが、しばらくしてからお試しください。</div>'
      + '</div></div>';
    return;
  }

  root.innerHTML = `
    <div class="csf-box">
      <div class="csf-log" role="log" aria-live="polite"></div>
      <p class="csf-note">ボタンを選ぶと自動でご案内します。</p>
    </div>`;
  const log = root.querySelector('.csf-log');

  // 計測: dataLayer へイベント送信（GTM経由でGA4等へ流す）。無ければ生成。失敗してもUXに影響させない
  function track(event, params) {
    var payload = Object.assign({ cs_brand: brand }, params || {});
    // GTM用（dataLayer）とGA4直送（gtag）の両方に送る。ESSINのGA4はGTMではなくgtag直載せのため
    try {
      (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: event }, payload));
    } catch (e) { /* noop */ }
    try {
      if (typeof window.gtag === 'function') window.gtag('event', event, payload);
    } catch (e) { /* noop */ }
  }

  function escapeHtml(s) {
    return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  // 回答中のURLをクリック可能なリンクにする（HTMLエスケープ後にURLだけ<a>化＝XSS防止）
  function linkify(text) {
    return escapeHtml(text).replace(
      /(https?:\/\/[^\s<]+)/g,
      '<a href="$1" target="_blank" rel="noopener">$1</a>'
    );
  }

  function bubble(role, text) {
    const div = document.createElement('div');
    div.className = 'csf-msg csf-' + role;
    if (role === 'assistant') {
      div.innerHTML = linkify(text); // 回答内リンクを有効化
    } else {
      div.textContent = text;
    }
    log.appendChild(div);
    log.scrollTop = log.scrollHeight;
    return div;
  }

  // 選択肢チップ群を表示。選択後はグレーアウトして再タップ不可にする
  // items: [{ label, onSelect?, line?, variant? }]
  function chips(items) {
    const wrap = document.createElement('div');
    wrap.className = 'csf-chips';
    items.forEach((item) => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'csf-chip' + (item.variant ? ' csf-chip--' + item.variant : '');
      btn.textContent = item.label;
      btn.addEventListener('click', () => {
        if (item.line) {
          track('cs_faq_line');
          if (LINE_URL) window.open(LINE_URL, '_blank', 'noopener');
          return;
        }
        wrap.classList.add('is-done');
        bubble('user', item.label);
        window.setTimeout(item.onSelect, 350);
      });
      wrap.appendChild(btn);
    });
    log.appendChild(wrap);
    log.scrollTop = log.scrollHeight;
  }

  function showCategories(message) {
    bubble('assistant', message || 'お問い合わせの内容をお選びください。');
    chips(data.categories.map((cat) => ({
      label: cat.name,
      onSelect: () => { track('cs_faq_category', { cs_category: cat.name }); showQuestions(cat); },
    })));
  }

  function showQuestions(cat) {
    bubble('assistant', `「${cat.name}」ですね。ご質問をお選びください。`);
    chips([
      ...cat.questions.map((qa) => ({ label: qa.q, onSelect: () => { track('cs_faq_question', { cs_category: cat.name, cs_question: qa.q }); showAnswer(cat, qa); } })),
      { label: '← 別のカテゴリを選ぶ', variant: 'back', onSelect: () => showCategories() },
    ]);
  }

  function showAnswer(cat, qa) {
    bubble('assistant', qa.a);
    window.setTimeout(() => {
      bubble('assistant', 'お役に立ちましたか？');
      chips([
        { label: '解決した', onSelect: () => { track('cs_faq_resolved', { cs_category: cat.name, cs_question: qa.q }); showCategories('よかったです。ほかにもご質問があれば、下からお選びください。'); } },
        { label: 'このカテゴリの他の質問を見る', onSelect: () => showQuestions(cat) },
        { label: '他のカテゴリを見る', onSelect: () => showCategories() },
        { label: '解決しなかった', variant: 'back', onSelect: () => { track('cs_faq_unresolved', { cs_category: cat.name, cs_question: qa.q }); showEscalation(); } },
      ]);
    }, 450);
  }

  // フローの最後（未解決時）にだけ公式LINEを案内する
  function showEscalation() {
    if (LINE_URL) {
      bubble('assistant', 'お力になれず申し訳ございません。公式LINEにて担当者が個別にご案内いたします。下のボタンからお進みください。');
      chips([
        { label: '公式LINEで相談する', line: true, variant: 'line' },
        { label: '← 最初のカテゴリに戻る', variant: 'back', onSelect: () => showCategories() },
      ]);
    } else {
      bubble('assistant', 'お力になれず申し訳ございません。恐れ入りますが、サポート窓口までお問い合わせください。');
      chips([{ label: '← 最初のカテゴリに戻る', variant: 'back', onSelect: () => showCategories() }]);
    }
  }

  track('cs_faq_open');
  showCategories(GREETING);
})();
